import React from "react";
import { useTranslation } from "react-i18next";
import arrow from "../../../../assets/images/rightArrowTiny.svg";
import { cn } from "_configs/twconfig";

type Props = {
    className?: string;
};

export function CommunityCardHeader({ className }: Props) {
    const { t } = useTranslation();

    return (
        <div className={cn("flex flex-row items-center text-sm justify-end", className)}>
            {t("propertiesPage.communitiesSection.viewMore")}
            <img src={arrow} alt={"arrow"} className={"ml-[5px]"} />
        </div>
    );
}
